import * as Yup from "yup";

import { Dispatch, bindActionCreators } from "redux";
import React, { Fragment, useEffect, useState } from "react";
import { maskCPF, maskData } from "../../utils";

import AdesaoActions from "../../store/ducks/adesao";
import Button from "../../components/Button";
import Error from "../../components/ErrorLabel";
import MaskedInput from "react-text-mask";
import MenuAside from "../../components/MenuAside";
import Progresso from "../../components/Progresso";
import RealizePrev from "../../support";
import { RootState } from "../../store/ducks";
import Titulo from "../../components/Titulo";
import Tooltip from "react-tooltip-lite";
import { connect } from "react-redux";
import { goToStep } from "../../services/navigation";
import moment from "moment";
import translate from "../../i18n";
import { useFormik } from "formik";
import { validate } from "gerador-validador-cpf";

interface Props {
  nextStep?: Function;
  previousStep?: Function;
  salvarParticipante?: Function;
  adesao?: {
    registros?: {
      dadosAdesao: {
        idPropostaAdesao: number;
      };
    };
  };
}

interface Beneficiario {
  id: number;
  idPropostaAdesao: number;
  nomeBeneficiario: string;
  nomeSocialBeneficiario?: string;
  cpfBeneficiario: string;
  sexo: string;
  dataNascimentoBeneficiario: string;
  percentualParticipacao: number;
  idUsuarioInclusao: number;
  dataInclusao: string;
  idUsuarioAlteracao: number;
  dataAlteracao: string;
}

const Beneficiarios: React.FC<Props> = ({
  nextStep,
  previousStep,
  salvarParticipante,
  adesao,
}) => {
  const [meusBeneficiarios, setMeusBeneficiarios] = useState<Beneficiario[]>(
    []
  );

  const [containerSocialNameHoverEnabled, setContainerSocialNameHoverEnabled] =
    useState(false);

  function verificaMaiorIdade() {
    const maiorIdade = sessionStorage.getItem("@RealizePrev:maiorIdade");
    if (maiorIdade === "true") {
      goToStep(3);
      window.scrollTo(0, 0);
    } else {
      previousStep!();
      window.scrollTo(0, 0);
    }
  }

  const formik = useFormik({
    initialValues: {
      beneficiario: {
        cpf: "",
        nome: "",
        nomeSocial: "",
        dataNascimento: "",
        sexo: "",
        percentual: 0,
      },
    },
    validationSchema: Yup.object({
      beneficiario: Yup.object({
        dataNascimento: Yup.string(),
        sexo: Yup.string(),
        nome: Yup.string(),
        cpf: Yup.string(),
        percentual: Yup.number()
          .typeError(translate.t("app.mensagem.validacaoPercentualSoNumeros"))
          .max(
            100,
            translate.t("app.mensagem.validacaoPercentualMaximoPermitido")
          ),
      }),
    }),
    onSubmit: (values) => {
      if (meusBeneficiarios.length === 0) {
        nextStep!();
        window.scrollTo(0, 0);
      } else {
        let percentualTotal = 0;
        meusBeneficiarios.forEach((beneficiario) => {
          percentualTotal += parseFloat(
            beneficiario.percentualParticipacao.toString()
          );
        });
        if (percentualTotal === 100) {
          if (meusBeneficiarios.length > 0) {
            meusBeneficiarios.forEach((beneficiario) => {
              if (beneficiario.nomeSocialBeneficiario === null) {
                delete beneficiario["nomeSocialBeneficiario"];
              }
            });

            salvarParticipante!({
              dadosAdesao: {
                ...adesao?.registros?.dadosAdesao,
                beneficiarios: meusBeneficiarios,
              },
            });
          }
          nextStep!();
          window.scrollTo(0, 0);
        } else {
          alert(translate.t("app.mensagem.validacaoPercentualTotal"));
        }
      }
    },
  });

  function handlePercentualChange(event: any) {
    formik.handleChange(event);

    let percentual = event.target.value;
    if (!Number(percentual)) {
      return;
    }
  }

  function handleAdicionar(event: any) {
    event.preventDefault();
    if (!formik.values.beneficiario.nome) {
      formik.setFieldError("beneficiario.nome", "Informe o Nome");
    }
    if (!formik.values.beneficiario.dataNascimento) {
      formik.setFieldError(
        "beneficiario.dataNascimento",
        translate.t("app.mensagem.validacaoDataNascimento")
      );
    }

    if (!formik.values.beneficiario.cpf) {
      formik.setFieldError(
        "beneficiario.cpf",
        translate.t("app.mensagem.validacaoCpf")
      );
    } else if (!validate(formik.values.beneficiario.cpf)) {
      formik.setFieldError(
        "beneficiario.cpf",
        translate.t("app.mensagem.validacaoCpfInvalido")
      );
    }
    if (!formik.values.beneficiario.sexo) {
      formik.setFieldError(
        "beneficiario.sexo",
        translate.t("app.mensagem.validacaoSexo")
      );
    }
    if (!formik.values.beneficiario.percentual) {
      formik.setFieldError(
        "beneficiario.percentual",
        translate.t("app.mensagem.validacaoPercentual")
      );
    }

    const cpfExistente = meusBeneficiarios.some(
      (beneficiario) =>
        beneficiario.cpfBeneficiario === formik.values.beneficiario.cpf
    );
    if (cpfExistente) {
      formik.setFieldError(
        "beneficiario.cpf",
        translate.t("app.mensagem.validacaoCpfExistente")
      );
    }

    if (
      formik.values.beneficiario.nome &&
      formik.values.beneficiario.dataNascimento &&
      formik.values.beneficiario.cpf &&
      validate(formik.values.beneficiario.cpf) &&
      !cpfExistente &&
      formik.values.beneficiario.sexo &&
      formik.values.beneficiario.percentual &&
      formik.values.beneficiario.percentual <= 100
    ) {
      const array = [
        ...meusBeneficiarios,
        {
          id: Math.random(),
          nomeBeneficiario: formik.values.beneficiario.nome,
          dataNascimentoBeneficiario: formik.values.beneficiario.dataNascimento,
          nomeSocialBeneficiario: formik.values.beneficiario.nomeSocial
            ? formik.values.beneficiario.nomeSocial
            : null,
          cpfBeneficiario: formik.values.beneficiario.cpf,
          sexo: formik.values.beneficiario.sexo,
          percentualParticipacao: formik.values.beneficiario.percentual,
          idUsuarioInclusao: RealizePrev().idUsuario,
          dataInclusao: moment(new Date()).format("DD/MM/YYYY"),
          dataAlteracao: moment(new Date()).format("DD/MM/YYYY"),
          idUsuarioAlteracao: RealizePrev().idUsuario,
          //idPropostaAdesao: adesao?.registros?.dadosAdesao.idPropostaAdesao,
        } as Beneficiario,
      ];

      setMeusBeneficiarios(array);

      formik.setFieldValue("beneficiario.nome", "");
      formik.setFieldValue("beneficiario.nomeSocial", "");
      formik.setFieldValue("beneficiario.dataNascimento", "");
      formik.setFieldValue("beneficiario.cpf", "");
      formik.setFieldValue("beneficiario.sexo", "");
      formik.setFieldValue("beneficiario.percentual", "");
    }
  }

  function handleExcluir(event: any, id: number) {
    event.preventDefault();

    const novoArrayBeneficiario = meusBeneficiarios.filter((beneficiario) => {
      return beneficiario.id !== id;
    });

    setMeusBeneficiarios(novoArrayBeneficiario);
  }

  return (
    <Fragment>
      <div className="content wrapper">
        <MenuAside step={3} />
        <form onSubmit={formik.handleSubmit}>
          <div className="container">
            <h2>
              <Tooltip
                className="ml-2"
                direction="left"
                background="black"
                color="white"
                content={
                  <>
                    <p>
                      {translate.t(
                        "app.tela.beneficiarios.tituloTooltip.parte1"
                      )}
                      <br />
                      {translate.t(
                        "app.tela.beneficiarios.tituloTooltip.parte2"
                      )}
                      <br />
                      {translate.t(
                        "app.tela.beneficiarios.tituloTooltip.parte3"
                      )}
                      <br />
                      {translate.t(
                        "app.tela.beneficiarios.tituloTooltip.parte4"
                      )}
                      <br />
                      {translate.t(
                        "app.tela.beneficiarios.tituloTooltip.parte5"
                      )}
                    </p>
                  </>
                }
              >
                {translate.t("app.tela.beneficiarios.titulo")}{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#17a2b8"
                  viewBox="0 0 24 24"
                  style={{ cursor: "pointer" }}
                >
                  <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 18.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25s-.559 1.25-1.25 1.25zm1.961-5.928c-.904.975-.947 1.514-.935 2.178h-2.005c-.007-1.475.02-2.125 1.431-3.468.573-.544 1.025-.975.962-1.821-.058-.805-.73-1.226-1.365-1.226-.709 0-1.538.527-1.538 2.013h-2.01c0-2.4 1.409-3.95 3.59-3.95 1.036 0 1.942.339 2.55.955.57.578.865 1.372.854 2.298-.016 1.383-.857 2.291-1.534 3.021z"></path>
                </svg>
              </Tooltip>
            </h2>

            <div className="pb-4  mb-4 mt-4">
              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-4">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.beneficiarios.label.nome")}
                    </label>
                    <input
                      type="text"
                      name="beneficiario.nome"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.beneficiario.nome}
                      className="form-control"
                    />

                    <Error error={formik.errors.beneficiario?.nome} />
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="form-group relative">
                    <label>
                      {translate.t(
                        "app.tela.beneficiarios.label.dataNascimento"
                      )}
                    </label>

                    <MaskedInput
                      type="text"
                      name="beneficiario.dataNascimento"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.beneficiario.dataNascimento}
                      className="form-control"
                      mask={maskData}
                    />
                    <Error error={formik.errors.beneficiario?.dataNascimento} />
                  </div>
                </div>
              </div>

              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-7">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: containerSocialNameHoverEnabled
                        ? "1px solid #17a2b8"
                        : "1px dashed",
                      borderRadius: "5px",
                      paddingRight: "10px",
                    }}
                    className="form-group relative"
                    onMouseEnter={() =>
                      setContainerSocialNameHoverEnabled(true)
                    }
                    onMouseLeave={() =>
                      setContainerSocialNameHoverEnabled(false)
                    }
                  >
                    <label style={{ cursor: "pointer" }}>
                      {translate.t("app.tela.beneficiarios.label.nomeSocial")}
                    </label>
                    <input
                      style={{
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                      }}
                      type="text"
                      name="beneficiario.nomeSocial"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.beneficiario.nomeSocial}
                      className="form-control"
                    />
                    <div style={{ display: "none" }} />
                    <Tooltip
                      className="ml-2"
                      direction="right"
                      background="black"
                      color="white"
                      content={
                        <>
                          <p>
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte1"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte2"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte3"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte4"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte5"
                            )}
                            <br />
                          </p>
                          <i>
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte6"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte7"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte8"
                            )}
                          </i>
                        </>
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#17a2b8"
                        viewBox="0 0 24 24"
                        style={{ cursor: "pointer" }}
                      >
                        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 18.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25s-.559 1.25-1.25 1.25zm1.961-5.928c-.904.975-.947 1.514-.935 2.178h-2.005c-.007-1.475.02-2.125 1.431-3.468.573-.544 1.025-.975.962-1.821-.058-.805-.73-1.226-1.365-1.226-.709 0-1.538.527-1.538 2.013h-2.01c0-2.4 1.409-3.95 3.59-3.95 1.036 0 1.942.339 2.55.955.57.578.865 1.372.854 2.298-.016 1.383-.857 2.291-1.534 3.021z"></path>
                      </svg>
                    </Tooltip>
                    <Error error={formik.errors.beneficiario?.nomeSocial} />
                  </div>
                </div>
              </div>

              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-2">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.beneficiarios.label.cpf")}
                    </label>

                    <MaskedInput
                      type="text"
                      name="beneficiario.cpf"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.beneficiario.cpf}
                      className="form-control"
                      mask={maskCPF}
                    />
                    <Error error={formik.errors.beneficiario?.cpf} />
                  </div>
                </div>

                <div className="col-lg-3">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.beneficiarios.label.sexo")}
                    </label>
                    <div>
                      <select
                        name="beneficiario.sexo"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.beneficiario.sexo}
                      >
                        <option value="">SELECIONE</option>
                        <option value="M">Masculino</option>
                        <option value="F">Feminino</option>
                      </select>
                    </div>
                    <Error error={formik.errors.beneficiario?.sexo} />
                  </div>
                </div>

                <div className="col-lg-2">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.beneficiarios.label.percentual")}
                    </label>
                    <input
                      type="text"
                      pattern="[0-9]*"
                      name="beneficiario.percentual"
                      onChange={handlePercentualChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.beneficiario.percentual}
                      className="form-control"
                    />
                    <Error error={formik.errors.beneficiario?.percentual} />
                  </div>
                </div>

                <div className="col-lg-4" onClick={handleAdicionar}>
                  <a href="#" className="btn btn--primary">
                    {translate.t("app.botao.adicionar")}
                  </a>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <hr className="generic-line" />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-12">
                  <h4 className="font-weight-bolder">
                    {translate.t(
                      "app.tela.beneficiarios.label.meusBeneficiarios"
                    )}
                  </h4>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        {translate.t("app.tela.beneficiarios.label.nome")}
                      </th>
                      <th>
                        {translate.t(
                          "app.tela.beneficiarios.label.dataNascimento"
                        )}
                      </th>
                      <th>{translate.t("app.tela.beneficiarios.label.cpf")}</th>
                      <th>
                        {translate.t("app.tela.beneficiarios.label.sexo")}
                      </th>
                      <th>
                        {translate.t("app.tela.beneficiarios.label.percentual")}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {meusBeneficiarios.map((beneficiario: any) => (
                      <tr key={beneficiario.id} className="text-secondary">
                        <td>{beneficiario.nomeBeneficiario}</td>
                        <td>{beneficiario.dataNascimentoBeneficiario}</td>
                        <td>{beneficiario.cpfBeneficiario}</td>
                        <td>
                          {beneficiario.sexo === "M" ? "Masculino" : "Feminino"}
                        </td>
                        <td>{beneficiario.percentualParticipacao}%</td>
                        <td
                          onClick={(event) => {
                            handleExcluir(event, beneficiario.id);
                          }}
                        >
                          <a href="#" className="btn btn--primary ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="#fff"
                              viewBox="0 0 24 24"
                            >
                              <path d="M9 19c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5-17v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712zm-3 4v16h-14v-16h-2v18h18v-18h-2z" />
                            </svg>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <p>
                    <small>
                      <em>{translate.t("app.mensagem.camposObrigatorios")}</em>
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="membership__pagination text-center mt-3">
            <Button
              previousStep={previousStep ? verificaMaiorIdade : () => {}}
            />

            <Button avancar previousStep={() => {}} />
          </div>
        </form>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  adesao: state.adesao,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(AdesaoActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Beneficiarios);
